export const LOCALSTORAGE_ORDER_NUMBER = 'orderNumber';
